import { Modal } from "ui/Modal"
import BookingDetails from "ui/Booking/Details"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getClientBookingDetails } from "store/bookings"
import PropTypes from "prop-types"
import { Flex, Spin } from "antd"

const BookingDetailsModal = ({ open, handleOnCancel, bookingUuid, onCancelSuccess, onAssignmentChange }) => {
  const dispatch = useDispatch()
  const { loading } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}

  useEffect(() => {
    dispatch(getClientBookingDetails(bookingUuid))
  }, [bookingUuid, dispatch])

  return (
    <Modal open={open} onCancel={handleOnCancel}>
      {loading ? (
        <Flex justify="center" align="center" style={{ minHeight: 200 }}>
          <Spin size="large" />
        </Flex>
      ) : (
        <BookingDetails uuid={bookingUuid} disableLoaderWatcher onCancelSuccess={onCancelSuccess} onAssignmentChange={onAssignmentChange} />
      )}
    </Modal>
  )
}

BookingDetailsModal.propTypes = {
  open: PropTypes.bool,
  handleOnCancel: PropTypes.func,
  bookingUuid: PropTypes.string,
  onCancelSuccess: PropTypes.func,
  onAssignmentChange: PropTypes.func
}

export default BookingDetailsModal
